// Import React, useState, and useEffect
import React, { useState, useEffect } from 'react';
import axios from 'axios';

import {SERVER_URL} from '../../constants' // Replace with your actual server URL

// AllOrders component
const AllOrders = () => {
  const [orderList, setOrderList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editStatus, setEditStatus] = useState("");
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/api/v1/orderall`);
        const { orders, addressId } = response.data;
        setOrderList(orders);
        console.log(orders)

        // Fetch address details for each addressId
        const addressPromises = addressId.map(async (id) => {
          const addressResponse = await axios.get(`${SERVER_URL}/api/v1/address/id/${id}`);
          return { id, ...addressResponse.data.address };
        });

        const resolvedAddresses = await Promise.all(addressPromises);
        setAddresses(resolvedAddresses);
      } catch (error) {
        console.error("Error fetching orders or addresses:", error);
      }
    };
    fetchOrders();
  }, []);

  const handleEditClick = (index, currentStatus) => {
    setEditIndex(index);
    setEditStatus(currentStatus);
  };

  const handleSaveClick = async (orderId) => {
    try {
      await axios.put(`${SERVER_URL}/api/v1/order/update-status/${orderId}`, { delivaryStatus: editStatus });
      setOrderList((prevOrders) => {
        const updatedOrders = [...prevOrders];
        updatedOrders[editIndex].deliveryStatus = editStatus;
        const fetchOrders = async () => {
          try {
            const response = await axios.get(`${SERVER_URL}/api/v1/orderall`);
            const { orders, addressId } = response.data;
            setOrderList(orders);
    
            // Calculate total sales
            const totalSales = orders.reduce(
              (sum, order) => sum + (order.totalAmount || 0),
              0
            );
           
    
            // Fetch address details for each addressId
            const addressPromises = addressId.map(async (id) => {
              const addressResponse = await axios.get(`${SERVER_URL}/api/v1/address/id/${id}`);
              return { id, ...addressResponse.data.address };
            });
    
            const resolvedAddresses = await Promise.all(addressPromises);
            setAddresses(resolvedAddresses);
          } catch (error) {
            console.error("Error fetching orders or addresses:", error);
          }
        };fetchOrders() 
        return updatedOrders;
        
      });
    
      setEditIndex(null);
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const deliveryStatusOptions = ["Order Placed", "Shipped", "Out for Delivery", "Delivered"];

  return (
    <div className="p-4 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">All Orders</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 px-4 py-2 text-left">Order ID</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Purchase Date</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Product Name</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Variation</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Email</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Phone</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Address</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Amount</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Payment Type</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Delivery Status</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {orderList.map((order, index) => (
              <tr key={order._id} className="hover:bg-gray-100">
                <td className="border border-gray-300 px-4 py-2">{order._id}</td>
                <td className="border border-gray-300 px-4 py-2">{order.createdAt}</td>
                <td className="border border-gray-300 px-4 py-2">{order.name}</td>
                <td className="border border-gray-300 px-4 py-2">{'Color: '+order.variation.color+' '+'Size: '+ order.variation.size}</td>
                <td className="border border-gray-300 px-4 py-2">{addresses[index]?.email || "N/A"}</td>
                <td className="border border-gray-300 px-4 py-2">{addresses[index]?.phone || "N/A"}</td>
                <td className="border border-gray-300 px-4 py-2">
                  {addresses[index]?.address ? (
                    `${addresses[index].address}, ${addresses[index].city}, ${addresses[index].state}, ${addresses[index].pincode}`
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="border border-gray-300 px-4 py-2">{order.totalAmount}</td>
                <td className="border border-gray-300 px-4 py-2">{order.paymentType}</td>
                <td className="border border-gray-300 px-4 py-2">
  {editIndex === index ? (
    <select
      value={editStatus}
      onChange={(e) => {setEditStatus(e.target.value)}}
      className="border border-gray-300 px-2 py-1 rounded text-black"
    >
      {deliveryStatusOptions.map((status, idx) => (
        <option key={idx} value={status} className="text-black">
          {status}
        </option>
      ))}
    </select>
  ) : (
    order.delivaryStatus // Display current delivery status if not editing
  )}
</td>
<td className="border border-gray-300 px-4 py-2">
  {editIndex === index ? (
    <button
      onClick={() => handleSaveClick(order._id)}
      className="bg-green-500 text-white px-3 py-1 rounded mr-2 hover:bg-green-600"
    >
      Save
    </button>
  ) : (
    <button
      onClick={() => handleEditClick(index, order.delivaryStatus)}
      className="bg-blue-500 text-white px-3 py-1 rounded mr-2 hover:bg-blue-600"
    >
      Edit
    </button>
  )}
</td>

              
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllOrders;
